import {FormProps} from "../../shared/types";
import {BooleanInput, SelectInput, SimpleForm, TextInput} from "react-admin";
import {initInput} from "../../shared/utils";
import {useOptionsResource} from "../../shared/hooks/useOptionsResource";

export const WorkPermitTypeForm = (props: FormProps) => {
    const {data: options} = useOptionsResource("GET");

    return options ?(
        <SimpleForm {...props}>
            <TextInput {...initInput("code", props.fieldOptions)} />
            <TextInput {...initInput("name", props.fieldOptions)} />
            <SelectInput {...initInput("unit", props.fieldOptions, props.canEdit, "array")}
                choices={props.fieldOptions.unit.choices}/>
            <BooleanInput {...initInput("file_required", props.fieldOptions)} />
        </SimpleForm>
    ) : null;
}